export let STATES = [];

/**
 * Fetches the states list from the server
 * and normalizes it into {code, gname, name}.
 */
export async function loadStates() {
  try {
    const res = await fetch('/api/method/zoni_edu.services.zahs_states');
    const json = await res.json();
    // rename name1 → name
    STATES = json.message.map(({ code, gname, name1 }) => ({
      code,
      gname,
      name: name1
    }));
  } catch (err) {
    console.error('Failed to load states:', err);
  }
}

export function populateStateSelects(selectIds = []) {
  selectIds.forEach(id => {
    const sel = document.getElementById(id);
    if (!sel) return;
    // get the current selected value
    const selectedValue = sel.value;
    // clear the select options
    sel.innerHTML = `<option value="">Select</option>`;
    STATES.forEach(s => {
      const o = document.createElement("option");
      o.value = s.code;
      o.textContent = s.name;
      // if the current option is the selected value, set it as selected
      if (s.code === selectedValue) {
        o.selected = true;
      }
      sel.appendChild(o);
    });
  });
}

// Initialize Select2
export function initStateSelect2(ids = []) {
  ids.forEach(id => {
    $(`#${id}`)
      .select2({
        theme: 'bootstrap-5',
        placeholder: "Select a state",
        allowClear: false,
      })
  });
}
